import { useQuery } from '@tanstack/react-query';

import { API_CACHE_KEYS } from '@/features/api/constants/cache';
import { useGrapevineOrganizationApi } from '@/features/api/hooks/grapevine-organization/useGrapevineOrganizationApi';
import { useAuth } from '@/features/authorization/provider/useAuth';
import { isEmptyOrNull } from '@/shared/utils/string';

export const useGetCommentPushSetting = (organizationId = '') => {
  const api = useGrapevineOrganizationApi();
  const { isAuthenticated } = useAuth();

  return useQuery({
    queryKey: [
      API_CACHE_KEYS.ORGANIZATION_COMMENT_PUSH_SETTING,
      organizationId
    ],
    queryFn: () => api.getCommentPushSetting({ organizationId }),
    enabled: isAuthenticated && !isEmptyOrNull(organizationId)
  });
};
